import { of, empty, from } from 'rxjs';
import { map, concatMap, catchError, switchMap, filter, delay } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import moment from 'moment';

import Http from '../../http/http';
import AppSettings from '../../app.settings';
import * as AssetDetailsActions from './asset-details.actions';
import { BuildUri, AssetModelHelper, DateRangeHelper } from './asset-details.util';
import { get } from 'lodash-es';

const taskes = [
  {
    index: 1,
    list: [
      'series',
      'faults',
      'attributes',
      'alerts',
      'maintenancePlans',
      'images',
      'users',
      'deviceCommands',
    ],
  },
];

export const getAssetData = (action$, state$) =>
  action$.pipe(
    ofType(AssetDetailsActions.GET_ASSET_DATA),
    switchMap((action) => {
      const equipmentId = action.payload;
      const user = state$.value.user;
      return of(...taskes).pipe(
        concatMap((includeTask) => {
          const thereIsMoreTask = includeTask.index !== taskes.length;
          return Http.get(
            BuildUri(`${AppSettings.BaseTugApiUrl}/equipment`, equipmentId, includeTask.list),
          ).pipe(
            map((data) =>
              AssetDetailsActions.getAssetDataSuccess(
                data,
                user,
                includeTask.list,
                thereIsMoreTask,
              ),
            ),
            catchError((error) => of(AssetDetailsActions.getAssetDataFailed(error))),
          );
        }),
        catchError((error) => {
          console.error(error);
          return empty();
        }),
      );
    }),
  );
export const mapToGetSeriesData = (action$) =>
  action$.pipe(
    ofType(
      AssetDetailsActions.SELECT_SERIES,
      AssetDetailsActions.SET_DATE_RANGE,
      AssetDetailsActions.SET_DATE_RANGE_BY_OPTION,
    ),
    map(() => AssetDetailsActions.getSeriesData()),
  );

const seriesDataRequest = (SeriesIds, range, uom, interval, functions) => {
  return {
    ids: SeriesIds,
    uom: uom,
    interval: interval,
    functions: functions,
    range: range,
  };
};

const getSeriesDataRequestTasks = (state) => {
  const { selectedSeriesIds = [], dataDateRange, activeDataTap } = state.asset_details;
  const uom = get(state.user, 'claims.data.unitOfMeasure');
  const { start, end } = dataDateRange;
  const interval = DateRangeHelper.getRangeAggregationInterval(start, end);
  const range = `${moment(start).toISOString()}/${moment(end).toISOString()}`;
  //when there is interval we need two set of data (raw for value, aggregated for chart)
  if (interval) {
    const chartTask = {
      DataFor: 'chart',
      request: seriesDataRequest(selectedSeriesIds, range, uom, interval, [
        'mean',
        'min',
        'max',
        'last',
        'first',
        'count',
        'delta',
      ]),
    };
    const valuesTask = {
      DataFor: 'values',
      request: seriesDataRequest(selectedSeriesIds, range, uom, null, null),
    };
    // to call data for active tab first
    return activeDataTap === 'chart' ? [chartTask, valuesTask] : [valuesTask, chartTask];
  }
  //if no interval
  const rawdataTask = {
    DataFor: 'all',
    request: seriesDataRequest(selectedSeriesIds, range, uom, null, null),
  };
  return [rawdataTask];
};
export const getSeriesData = (action$, state$) =>
  action$.pipe(
    ofType(AssetDetailsActions.GET_SERIES_DATA),
    filter(() => {
      const { selectedSeriesIds = [] } = state$.value.asset_details;
      return selectedSeriesIds.length > 0;
    }),
    switchMap(() => {
      const dataTasks = getSeriesDataRequestTasks(state$.value);
      return of(...dataTasks).pipe(
        concatMap((dataTask) =>
          Http.post(`${AppSettings.BaseTugApiUrl}/series/data`, dataTask.request).pipe(
            map((data) => AssetDetailsActions.getSeriesDataSuccess(data, dataTask.DataFor)),
            catchError((error) => of(AssetDetailsActions.getSeriesDataFailed(error))),
          ),
        ),
      );
    }),
  );

export const ckeckAssetDataIntegrity = (action$, state$) =>
  action$.pipe(
    ofType(AssetDetailsActions.GET_SERIES_DATA_SUCCESS),
    concatMap((action) => {
      const { asset = {} } = state$.value.asset_details;
      const assetStillGood = AssetModelHelper.validateAssetDataIntegrity(
        action.payload.seriesList,
        asset.series,
      );
      return assetStillGood ? empty() : of(AssetDetailsActions.getAssetData(asset.id));
    }),
    catchError((error) => {
      console.error(error);
      return empty();
    }),
  );

/**
 * fire action to get the asset then wait for 500ms befor fire action get series Data
 * @param {*} action$
 */
export const refreshAssetDashBoardData = (action$) =>
  action$.pipe(
    ofType(AssetDetailsActions.REFRESH_ASSET_DASH_BOARD_DATA),
    switchMap((action) => {
      return from([
        of(AssetDetailsActions.getAssetData(action.payload)),
        of(AssetDetailsActions.getSeriesData()).pipe(delay(500)),
      ]).pipe(concatMap((observableAction) => observableAction));
    }),
  );
